import type { GetTextColor } from './types'

export const getTextColor = ({ isManual, hexTextColor, palette }: GetTextColor) => {
  if (isManual) {
    return palette.text.primary
  }

  return hexTextColor ?? palette.common.white
}
